import { StoreOptions } from 'vuex';
import Cookies from 'js-cookie';
import vistorIns from '@/renderer/scripts/utils/vistor';
export interface VistorState {
  isVistorLogined: boolean;
  collectToken: string;
  vistorPhoneNumber: string;
}
// 存储 collect 收集文件票据的key
const vistor: StoreOptions<VistorState> = {
  state: {
    isVistorLogined: false,
    collectToken: '',
    vistorPhoneNumber: '',
  },
  mutations: {
    SET_COLLECT_TOKEN: (state: VistorState, collectToken: string): void => {
      state.collectToken = collectToken;
    },
    SET_VISTOR_LOGINED: (state: VistorState, isVistorLogined: boolean): void => {
      state.isVistorLogined = isVistorLogined;
    },
    SET_VISTOR_PHONE_NUMBER: (state: VistorState, vistorPhoneNumber: string): void => {
      state.vistorPhoneNumber = vistorPhoneNumber;
      Cookies.set('VISTOR_PHONE_NUMBER', vistorPhoneNumber);
    },
  },
  getters: {
    collectToken: (state: VistorState) => state.collectToken,
    isVistorLogined: (state: VistorState) => {
      // 避免初始化store的isLogined里信息和user里的isLogined不同步
      const { isVistorLogined } = vistorIns.getVistorInfoSync();
      state.isVistorLogined = isVistorLogined || false;
      return state.isVistorLogined;
    },
    vistorPhoneNumber: (state: VistorState) => state.vistorPhoneNumber,
  },
};
export default vistor;
